import { useUiVersion } from 'hooks';
import { Subscription } from 'grids/subscription/subscription';

export const SubscriptionWrapper = (props) => {
  const { isNew } = useUiVersion();
  const theme = isNew ? undefined : 'dark';

  return <Subscription {...props} theme={theme} className="in-client" />;
};
